import { api } from "@//api";
import { queryClient } from "@/queryClient";
import { type BookingForm } from "./bookingForm";
import {
  type Booking,
  type BookingApiResponse,
  parseBookingApiResponse,
} from "./bookings";
import {
  type CreateUpdateBookingRequestBody,
  parseBookingForm,
} from "./createUpdateBookings";

type CreateBookingRequest = CreateUpdateBookingRequestBody;

export const createBooking = async (
  formValues: BookingForm,
): Promise<Booking> => {
  const requestBody: CreateBookingRequest = parseBookingForm(formValues);

  const { body: responseBody } = await api.post<BookingApiResponse>(
    "/bookings/",
    {
      body: requestBody,
    },
  );

  queryClient.invalidateQueries([BOOKINGS_QUERY_KEY]);

  return parseBookingApiResponse(responseBody);
};
